import styled from 'styled-components';


const DefaultParagraph = styled.p<{ color?: string, align?: string }>`
  color: ${({ color, theme }) => color ?? theme.colors.white};
  text-align: ${({ align }) => align ?? 'left'};
  font-weight: 500;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    font-size: ${({ theme }) => theme.fontSize.medium};
  }
`;

export default DefaultParagraph;
